import { ApiClient } from "./ApiClient";

// Create atom runtime with API client
export const runtime = ApiClient.runtime;
